/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

import ProducerDelegate from "@/libs/common/delegate/ProducerDelegate";
import * as lob from "lodash/object";
import ProducerDelegateHandler from "@/libs/common/delegate/ProducerDelegateHandler";

export default class DefaultProducerDelegateHandler
  implements ProducerDelegateHandler
{
  private delegates: ProducerDelegate[] = [];
  private delegatesWithName: any = {};
  private names: string[] = [];
  constructor() {}

  add(dg: ProducerDelegate, name?: string): void {
    if (dg === undefined || dg === null) {
      return;
    }

    if (name !== undefined) {
      if (!this.names.includes(name)) {
        this.names.push(name);
      }

      lob.set(this.delegatesWithName, name, dg);
      return;
    }

    this.delegates.push(dg);
  }

  delegate(src?: any, obj?: any, name?: string): any {
    const that = this;

    if (name !== undefined) {
      const dg = lob.get(this.delegatesWithName, name);
      if (dg !== undefined) {
        return dg(src, obj, name);
      }
      return undefined;
    }

    if (this.delegates.length > 0) {
      const delegate = this.delegates[0];
      return delegate(src, obj);
    }

    return undefined;
  }

  hasDelegate(name?: string): boolean {
    if (name !== undefined) {
      if (this.names.includes(name)) {
        return true;
      }

      return false;
    }

    if (this.delegates.length > 0) {
      return true;
    }

    return false;
  }
}
